var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_3719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.916 4.33333H4.33268C3.75805 4.33333 3.20695 4.5616 2.80062 4.96793C2.39429 5.37426 2.16602 5.92536 2.16602 6.5V21.6667C2.16602 22.2413 2.39429 22.7924 2.80062 23.1987C3.20695 23.6051 3.75805 23.8333 4.33268 23.8333H19.4993C20.074 23.8333 20.6251 23.6051 21.0314 23.1987C21.4377 22.7924 21.666 22.2413 21.666 21.6667V14.0833M20.041 2.70833C20.472 2.27735 21.0565 2.03523 21.666 2.03523C22.2755 2.03523 22.86 2.27735 23.291 2.70833C23.722 3.13931 23.9641 3.72384 23.9641 4.33333C23.9641 4.94282 23.722 5.52735 23.291 5.95833L12.9993 16.25L8.66602 17.3333L9.74935 13L20.041 2.70833Z",
    stroke: "#478F96",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_3719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit_green.ee27488788a2151f236e9b7fd6685f5c.svg";
export { ForwardRef as ReactComponent };